module.exports = __webpack_public_path__ + "static/media/cardsLoading.6591a604.gif";